import { render, staticRenderFns } from "./POD-10View.vue?vue&type=template&id=73ed0696&scoped=true"
import script from "./POD-10View.vue?vue&type=script&lang=js"
export * from "./POD-10View.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ed0696",
  null
  
)

export default component.exports